// extracted by mini-css-extract-plugin
export default {"wrapper":"ReportsTable_wrapper__Mxdk6","tableGeneral":"ReportsTable_tableGeneral__9xTac","tableGeneralHeader":"ReportsTable_tableGeneralHeader__L4Twg"};